module.exports = __webpack_public_path__ + "media/images/banner-cf.png@3x-ce92d736649e77021e226675d6bdb5bc.png";